import { render, staticRenderFns } from "./LmsCourseSection.vue?vue&type=template&id=3f43db72&scoped=true"
import script from "./LmsCourseSection.vue?vue&type=script&lang=js"
export * from "./LmsCourseSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43db72",
  null
  
)

export default component.exports